module.exports = __webpack_public_path__ + "fonts/Lato-700-latin-ext7.a48b0f0.woff2";